import React from 'react';
import { useScrollToTop } from '../hooks/useScrollToTop';

const ScrollToTop: React.FC = () => {
  useScrollToTop();
  return null;
};

export default ScrollToTop; 